import React, { useState, useEffect } from 'react';
import { object, func, bool, string } from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { ALERT_TYPE, ShowToastMessage, sequenceActionNext } from '@laramie/ui';
import { TableCustom, MessageModal } from '../../common';
import { CloneObject } from '../../../utils/helpers';
import { useEntidad } from '../../hooks/useEntidad';
import SubTasaImputacionModal from '../SubTasaImputacionModal';
import DataTaggerModalRedux from '../DataTaggerModalRedux';
import { isNull } from '../../../utils/validator';
import {TIPS} from "../../../consts/tips";


const SubTasaImputacionesGrid = (props) => {

  //hooks
  const [state, setState] = useState({
      idTasa: 0,
      idSubTasa: 0,
      disabled: false,
      showMessage: false,
      showForm: false,
      modeFormEdit: false,
      rowForm: null,
      dataTagger: {
        showModal: false,
        idEntidad: null
      },      
      list: []
  });

  const dispatch = useDispatch();
  const sequenceValue = useSelector( (state) => state.sequence.value );

  const mount = () => {
    setState(prevState => {
      const list = props.data.list.filter(x => x.state !== 'r');
      return {...prevState,
        idTasa: props.data.idTasa,
        idSubTasa: props.data.idSubTasa,
        list: list };
    });
  }
  useEffect(mount, [props.data]);

  const [getListEntidad, getRowEntidad,] = useEntidad({
    entidades: ['Jurisdiccion', 'RecursoPorRubro', 'CuentaContable'],
    onLoaded: (entidades, isSuccess, error) => {
      if (!isSuccess) {
        ShowToastMessage(ALERT_TYPE.ALERT_ERROR, error);
      }
    },
    memo: null
  });


  const cellA = (data) =>    <div className='action'>
                                {!props.disabled && (
                                  <div onClick={ (event) => handleClickSubTasaImputacionAdd() } className="link">
                                      <span className="material-symbols-outlined" title="Nuevo">add</span>
                                  </div>
                                )}
                              </div>
  const cellVMR = (data) =>  <div className='action'>
                                  <div onClick={ (event) => handleClickSubTasaImputacionView(data.value) } className="link">
                                  <span className="material-symbols-outlined" title="Ver">search</span>
                                  </div>
                                  {!props.disabled && (
                                  <div onClick={ (event) => handleClickSubTasaImputacionModify(data.value) } className="link">
                                      <span className="material-symbols-outlined" title="Modificar">stylus</span>
                                  </div>
                                  )}
                                  {!props.disabled && (
                                  <div onClick={ (event) => handleClickSubTasaImputacionRemove(data.value) } className="link">
                                      <span className="material-symbols-outlined" title="Eliminar">delete</span>
                                  </div>
                                  )}
                                  <div onClick={ (event) => handleClickSubTasaImputacionesDataTagger(data.value) } className="link">
                                  <span className="material-symbols-outlined" title="Información adicional">info</span>
                                  </div>                                  
                              </div>

  const getDescJurisdiccionActual = (id) => {
    const row = getRowEntidad('Jurisdiccion', id);
    return (row) ? row.nombre : '';
  }
  const getDescRecursoPorRubroActual = (id) => {
    const row = getRowEntidad('RecursoPorRubro', id);
    return (row) ? row.nombre : '';
  }
  const getDescCuentaContableActual = (id) => {
    const row = getRowEntidad('CuentaContable', id);
    return (row) ? row.nombre : '';
  }

  const tableColumns = [
    { Header: 'Ejercicio', id:'ejercicio', accessor: 'ejercicio', width: '10%' },
    { Header: 'Cuenta contable actual', Cell: (props) => getDescCuentaContableActual(props.value), accessor: 'idCuentaContable', width: '27%' },
    { Header: 'Jurisdicción actual', Cell: (props) => getDescJurisdiccionActual(props.value), accessor: 'idJurisdiccionActual', width: '27%' },
    { Header: 'Recurso por rubro actual', Cell: (props) => getDescRecursoPorRubroActual(props.value), accessor: 'idRecursoPorRubroActual', width: '27%' },
    { Header: cellA, Cell: cellVMR, id:'abm', accessor: 'id', width: '9%', disableGlobalFilter: true, disableSortBy: true }
  ];


  //handles
  const handleClickSubTasaImputacionAdd = () => {
    const idTemporal = (-1)*sequenceValue; //los registros temporales tienen id negativa
    setState(prevState => {
      const rowForm = {
        id: idTemporal,
        idTasa: state.idTasa,
        idSubTasa: state.idSubTasa,
        ejercicio: "",
        idTipoCuota: 0,
        idCuentaContable: 0,
        idCuentaContableAnterior: 0,
        idCuentaContableFutura: 0,
        idJurisdiccionActual: 0,
        idRecursoPorRubroActual: 0,
        idJurisdiccionAnterior: 0,
        idRecursoPorRubroAnterior: 0,
        idJurisdiccionFutura: 0,
        idRecursoPorRubroFutura: 0,
        codigoFormaPago: "",
		    codigoTipoRecaudacion: "",
        state: 'a'
      };
      return {...prevState, showForm: true, modeFormEdit: true, rowForm: rowForm};
    });
    dispatch( sequenceActionNext() );
  }
  const handleClickSubTasaImputacionView = (id) => {
    setState(prevState => {
      const rowForm = state.list.find(x => x.id === id);
      return {...prevState, showForm: true, modeFormEdit: false, rowForm: rowForm};
    });
  }
  const handleClickSubTasaImputacionModify = (id) => {
    setState(prevState => {
      const rowForm = state.list.find(x => x.id === id);
      return {...prevState, showForm: true, modeFormEdit: true, rowForm: rowForm};
    });
  }
  const handleClickSubTasaImputacionRemove = (id) => {
    setState(prevState => {
      const rowForm = state.list.find(x => x.id === id);
      return {...prevState, showMessage: true, rowForm: rowForm};
    });
  }

  const handleClickSubTasaImputacionesDataTagger = (id) => {
    setState(prevState => {
      return {...prevState, dataTagger: {showModal: true, idEntidad: id}};
    });
  }  

  //funciones
  function RemoveSubTasaImputacion(row) {
    row.state = 'r';
    props.onChange('SubTasaImputacion', row);
  }

  function UpdateSubTasaImputacion(row) {
    row.state = isNull(state.list.find(x => x.id === row.id)) ? 'a' : 'm';
    props.onChange('SubTasaImputacion', row);
  }

  return (
  <>

    {state.dataTagger.showModal &&
      <DataTaggerModalRedux
          title="Información adicional de imputaciones"
          tipName={TIPS.NAME.MODALS.INFORMACION_ADICIONAL_IMPUTACIONES_MODAL}
          processKey={props.processKey}
          entidad="SubTasaImputacion"
          idEntidad={state.dataTagger.idEntidad}
          disabled={props.disabled}
          onDismiss={() => {
            setState(prevState => {
              return {...prevState, dataTagger: {showModal: false, idEntidad: null}};
            });
          }}
      />
    }

    {state.showMessage && 
        <MessageModal
            title={"Confirmación"}
            message={"¿Está seguro de borrar el registro?"}
            onDismiss={() => {
              setState(prevState => {
                  return {...prevState, showMessage: false, rowForm: null};
              });
            }}
            onConfirm={() => {
              const row = CloneObject(state.rowForm);
              setState(prevState => {
                  return {...prevState, showMessage: false, rowForm: null};
              });
              RemoveSubTasaImputacion(row);
            }}
        />
    }

    {state.showForm && 
        <SubTasaImputacionModal
            processKey={props.processKey}
            disabled={!state.modeFormEdit}
            data={{
              entity: state.rowForm,
              lists: {
                Jurisdiccion: getListEntidad("Jurisdiccion"),
                RecursoPorRubro: getListEntidad("RecursoPorRubro"),
                CuentaContable: getListEntidad("CuentaContable")
              }
            }}
            onDismiss={() => {
              setState(prevState => {
                  return {...prevState, showForm: false, rowForm: null};
              });
            }}
            onConfirm={(row) => {
              setState(prevState => {
                  return {...prevState, showForm: false, rowForm: null};
              });
              UpdateSubTasaImputacion(row);
            }}
        />
    }

    <TableCustom
        showFilterGlobal={false}
        className={'TableCustomBase'}
        columns={tableColumns}
        data={state.list}
    />

  </>
  );
}

SubTasaImputacionesGrid.propTypes = {
  processKey: string.isRequired,
  disabled: bool,
  data: object.isRequired,
  onChange: func.isRequired
};

SubTasaImputacionesGrid.defaultProps = {
  disabled: false
};

export default SubTasaImputacionesGrid;